import React from 'react';

import { ProductsListBar, ProductsListBarTypes } from '../../../../components/ProductsListBar';
import { NormalizedDistributionProduct } from '../../../../store/managementAnalysis/types';

export declare namespace ProductsBarTypes {
  interface Props {
    products?: NormalizedDistributionProduct[];
    isMobile?: boolean;
    activeDataKey?: ProductsListBarTypes.Props['activeDataKey'];
    setActiveDataKey: ProductsListBarTypes.Props['setActiveDataKey'];
  }
}

export const ProductsBar = ({
  products,
  isMobile,
  activeDataKey,
  setActiveDataKey,
}: ProductsBarTypes.Props) => {
  return (
    <ProductsListBar
      setActiveDataKey={setActiveDataKey}
      activeDataKey={activeDataKey}
      isMobile={isMobile}
      products={(products || []).map((product) => ({
        color: product.color,
        dataKey: product.productClassName,
        percentage: product.productClassPercentage,
        percentageFormatted: product.productClassPercentageFormatted,
        label: product.label,
        value: product.productClassValue,
      }))}
    />
  );
};

ProductsBar.displayName = 'ProductsBar';
